import React from "react";
import { ContentViewProps } from "./types";

export const ContentView = (props: ContentViewProps) => {
	return <React.Fragment>{props.content}</React.Fragment>;
};
